module.exports = "<!-- For Loading the images -->\n\n<div fxLayout=\"column\" class=\"ImageMainCategoriesCon\">\n  <app-mediacommon [bookObj]=\"bookObj\" [updateData]=\"ImageDataUrl\" (onSelectGimage)=\"onChangeGalleryimage($event)\" style=\"height:100%;\"></app-mediacommon>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/image/imageGallerymedia/imageGallerymedia.component.html
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/image/imageGallerymedia/imageGallerymedia.component.html
// module chunks = main